import React from "react";
import { motion } from "framer-motion";
import cvData from "../data/cvData";
import { easing } from "../utils/motionVariants";
import "./WhatsAppFloat.css";

export default function WhatsAppFloat() {
  const { contacts } = cvData;
  const whatsappNumber = (contacts.phone || "").replace(/\D/g, "");
  if (!whatsappNumber) return null;

  const whatsappText = encodeURIComponent(
    "Hi Hirun, I came from your portfolio website and would like to chat."
  );
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappText}`;

  return (
    <motion.a
      className="wa-float"
      href={whatsappUrl}
      aria-label="Chat on WhatsApp"
      target="_blank"
      rel="noreferrer"
      title="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0, y: 40 }}
      animate={{
        opacity: 1,
        scale: 1,
        y: 0,
        transition: { delay: 1.2, duration: 0.5, ease: easing },
      }}
      whileHover={{ scale: 1.12, rotate: -8 }}
      whileTap={{ scale: 0.92 }}
    >
      <motion.img
        src="/assets/whatsapp.png"
        alt="WhatsApp"
        className="wa-icon"
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />
    </motion.a>
  );
}
